<template>
  <div>
    <div class="demo-title">
      <SectionTitle>
        <!-- Veja o que dizem os clientes que escolheram nossos serviços: -->
        <!-- Clientes que escolheram o melhor nunca mais voltaram ao antigo! -->
        Avaliações de nossos clientes:
      </SectionTitle>
      <div class="foward-backward-buttons">
        <v-btn
          icon
          @click="prevSlide"
          class="button"
          aria-label="Voltar ao slide anterior"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-btn
          icon
          @click="nextSlide"
          class="button"
          aria-label="Avançar para o próximo slide"
        >
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="carousel-container mt-8">
      <div class="swiper testimonialsSwiper">
        <div class="swiper-wrapper">
          <div
            v-for="(item, i) in testimonials"
            :key="i"
            class="swiper-slide d-flex flex-column align-center"
          >
            <v-card
              class="testimonial-card"
              outlined
            >
              <v-row
                align="center"
                class="card-header"
              >
                <v-col
                  cols="2"
                  class="profile-icon"
                >
                  <v-avatar
                    size="32"
                    color="red"
                  >
                    <img
                      :src="require(`@/assets/images/clientes/${item.image}`)"
                      width="32"
                      height="32"
                      aspect-ratio="1"
                      :alt="`cliente ${item.image}`"
                    />
                  </v-avatar>
                </v-col>
                <v-col>
                  <div class="testimonial-name">{{ item.name }}</div>
                  <div class="testimonial-company">{{ item.company }}</div>
                </v-col>
              </v-row>

              <p class="testimonial-text">"{{ item.message }}"</p>
            </v-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SectionTitle from '@/components/SectionTitle.vue';

  export default {
    name: 'TestimonialsCarousel',

    components: {
      SectionTitle,
    },

    data: () => ({
      testimonials: [
        {
          name: 'Angela ⭐⭐⭐⭐⭐',
          company: 'PitStop Burguer',
          image: 'pitstop.png',
          message:
            'Se tivesse que resumir minha experiência em uma palavra, seria "excelência" ❤️ Não se trata apenas de um atendimento otimizado, é uma gestão completa da minha empresa... Pessoal sempre muito solícitos, suporte maravilhoso. Super recomendo.',
        },
        {
          name: 'Daiana ⭐⭐⭐⭐⭐',
          company: 'Amorim',
          image: 'amorim.png',
          message:
            'Maravilhoso, uma equipe sempre disponível para atender a gente e tirar nossas dúvidas. O aplicativo é maravilhoso, o sistema imprime automaticamente quando o cliente envia o pedido. Muito top, estão de parabéns ❤️',
        },
        {
          name: 'Kelly ⭐⭐⭐⭐⭐',
          company: 'Cuscuzeria Sabor do Nordeste',
          image: 'cuscuzeria.png',
          message:
            'Estou muito satisfeita com essa equipe. Super atenciosos e tratam a gente com muito carinho. Meu cardápio ficou perfeito e eu ameiii. Super indicooooooo👏👏👏👏',
        },
        {
          name: 'Ricardo ⭐⭐⭐⭐⭐',
          company: 'Bois Burguer',
          image: 'bois.jpg',
          message:
            'Com certeza o melhor investimento feito. Plataforma sensacional, a equipe de suporte está de parabéns 👏. Super recomendo!',
        },
        {
          name: 'Paulo ⭐⭐⭐⭐⭐',
          company: 'Kabanas Cruzeiro Delivery',
          image: 'kabanas.jpg',
          message:
            'Top demais, melhorou 100% a gestão e a forma de trabalho de nossa empresa!!! Ótimos profissionais e atendimento de qualidade 😃👏',
        },
        {
          name: 'Wellington ⭐⭐⭐⭐⭐',
          company: 'Punch Comedoria',
          image: 'punch.png',
          message:
            'Não existe sistema melhor! O ZaperMenu é o melhor em todo os aspectos... Atendimento, preço, facilidade, utilidade, ferramentas e mais uma infinidade de vantagens que eu teria que escrever um texto gigante para descrever tudo!',
        },
        {
          name: 'Roberto ⭐⭐⭐⭐⭐',
          company: 'Prime Burguer',
          image: 'prime-burguer.png',
          message:
            'Vale o investimento, tem uns mais baratos mas não é a mesma coisa não, além do atendimento achei o ZaperMenu mais intuitivo, perfeito!',
        },
      ],
    }),

    mounted() {
      // eslint-disable-next-line
      this.$swiper = new Swiper('.testimonialsSwiper', {
        slidesPerView: 2,
        spaceBetween: 10,
        loop: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
      });
    },
    methods: {
      nextSlide() {
        this.$swiper.slideNext();
      },
      prevSlide() {
        this.$swiper.slidePrev();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .demo-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    :deep(.section-title) {
      width: 50%;
      line-height: 56px;
      font-size: 32px;
    }
    @media (max-width: 768px) {
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      :deep(.section-title) {
        width: 100%;
        line-height: 32px;
        font-size: 24px;
        margin-bottom: 16px;
      }
    }
    .foward-backward-buttons {
      display: flex;
      gap: 16px;
      .button {
        border: 1px solid #c3121a;
        background-color: var(--btn-icon-bg);
        color: var(--text-primary);
        :deep(.v-icon) {
          font-size: 18px;
        }
      }
    }
  }
  .carousel-container {
    width: 100%;
    overflow: hidden;        /* corta os slides que saem da tela */
    padding: 16px 8px 24px; /* espaço para a sombra respirar */
  }

  /* Swiper tem overflow:hidden por padrão — sobrescreve para a sombra aparecer */
  :deep(.swiper) {
    overflow: visible !important;
  }

  .img-fluid {
    max-width: 100%;
    height: auto;
  }

  .testimonial-card {
    background-color: var(--card-bg);
    padding: 32px 16px 0 16px;
    border-radius: 24px;
    max-width: 300px;
    height: 300px;
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.3);

    .card-header {
      .profile-icon {
        padding-right: 0 !important;
      }
    }
  }

  .profile-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .testimonial-name {
    font-weight: bold;
    font-size: 16px;
  }

  .testimonial-company {
    font-size: 12px;
    color: var(--text-hint);
  }

  .testimonial-text {
    font-size: 14px;
    margin-top: 10px;
    padding: 8px;
    color: var(--text-primary);
  }
</style>
